import { Fragment } from "react/jsx-runtime";
import { EnrollmentCertificate } from "../../../Physician/Models/CCEnrollment";
import { Col, Row } from "react-bootstrap";
import CCEnrollmentCertificateAssessment from "./CCEnrollmentCertificateAssessment";
import { AbccAssessment, AbccAssessmentModule } from "../Models/CCAssessment";
import Physician from "../../../Physician/Models/Physician";
import { Certificate } from "../../../Physician/Models/Certificate";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";

interface IProps{
    physician: Physician;
    ccEnrollmentCertificate: EnrollmentCertificate;
    abccAssessments: AbccAssessment[];
    acceptAbccModuleAttestation: (abccAssessmentModule: AbccAssessmentModule) => void;
    
}

export default function CCEnrollmentCertficateSummaryCard(props: IProps) {
    const certificate = props.physician.certificates.find((cert: Certificate) => cert.certificateId == props.ccEnrollmentCertificate.certificateId);
    var expirationDate  = getDateWithOffset(certificate.expirationDate);
    
    return (
        <Fragment>
            <Row className="ccenrollment-certificate-summary">
                <Col>
                    <Row className="ccenrollment-certificate-header">
                        <Col>
                            <div className="mb-0 font-weight-bolder card-title font-size-20"><span>{certificate.certificationName}</span></div>
                        </Col>
                        <Col>
                            <div className="mb-0 font-weight-bolder card-title font-size-20">Assessment Due in Year: <b>{expirationDate.getFullYear()}</b></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <CCEnrollmentCertificateAssessment ccEnrollmentCertificate={props.ccEnrollmentCertificate} abccAssessments={props.abccAssessments} acceptAbccModuleAttestation={props.acceptAbccModuleAttestation} />
                        </Col>
                    </Row>
                    
                    </Col>
                </Row>
        </Fragment>
    );

}